import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { useGetSdkVersionQuery, useUpdateSdkVersionMutation } from '../../api/sdkVersionApiSlice';
import Block from '../Block';
import Icon from '../Icon';
import useCustomTable from '../tables/useCustomTable';
import Title from '../Title';
import NewsletterModal from './NewsletterModal';
import { Button, Form } from 'react-bootstrap';
import Table from '../tables/Table';

const AppTableBlock = ({apps}) => {
  const { t } = useTranslation()
  const history = useHistory()
  const {
    tableProps,
    paginationProps,
    tableFilterProps,
    tableSearchProps
  } = useCustomTable({
    sortable: true,
    paginate: true,
    sortBy: {name: 'asc'}
  });
  const columns = useMemo(() => [{
    Header: t("app.tabName"),
    accessor: 'name',
  },{
    Header: t("app.environment"),
    accessor: 'environment',
  },{
    Header: t("app.isCmp"),
    accessor: 'isCmp',
    Cell: ({row}) => ( row.original.isCmp ? "true" : "false"),
  },{
    Header: t("app.testedAt"),
    accessor: 'testedAt',
    format: 'date'
  },{
    Header: t("app.productionAt"),
    accessor: 'productionAt',
    format: 'date'
  },]);
  const goToApp = (rowData) => history.push(`/apps/${rowData.slug}`)

  return (<>
    <Block title={"Apps"}>
      <Table
        // noPadding
        data={apps}
        columns={columns}
        onRowClick={goToApp}
        {...tableProps} />
    </Block>
  </>)
}

const ChangeLogShow = ({sdkVersion, onEdit, openNewsletter}) => {
  const { t } = useTranslation()
  const pageRef = useRef()
  const history = useHistory()

  return (
    <>
      <Title main={"SDK Version"} sub={`${sdkVersion.version} (${sdkVersion.os})`} onBack={()=>history.push(`/sdk/sdk_versions`)}>
        <Button key="send" variant="primary" onClick={()=>{openNewsletter()}}>
          <Icon icon='send' text={t("newsletter")} />
        </Button>
        <Button key="edit" variant="primary" onClick={onEdit}>
          <Icon icon='edit' text={t("edit")} />
        </Button>
      </Title>
      <Block title={t("sdkVersion.changeLog")}>
        <div ref={pageRef} dangerouslySetInnerHTML={{ __html: sdkVersion.formattedChangeLog }} />
      </Block>
    </>
  )
}

const ChangeLogEdit = ({sdkVersion, value, onCancel, onSave, onChange}) => {
  const { t } = useTranslation()

  return (<>
    <Title main={"SDK Version"} sub={`${sdkVersion.version} (${sdkVersion.os})`} group={false}>
      <Button key="cancel" variant="secondary" onClick={onCancel}>
        <Icon icon='cancel' text={t("cancel")} />
      </Button>
      <Button key="save" variant="primary" onClick={onSave}>
        <Icon icon='save' text={t("save")} />
      </Button>
    </Title>
    <Block title={t("sdkVersion.changeLog")}>
      <Form.Group>
        <Form.Control as="textarea" rows={3} value={value} onChange={(e) => (onChange(e.target.value))} />
      </Form.Group>
    </Block>
  </>)
}


const SdkVersion = () => {
  const {sdkVersion} = useParams()
  const { t } = useTranslation()
  const { data, isLoading, isError, isSuccess } = useGetSdkVersionQuery(sdkVersion)
  const [edit, setEdit] = useState(false)
  const [changeLog, setChangeLog] = useState("")
  const [newsletterPopupOpen, setNewsletterPopupOpen] = useState(false)
  const [save] = useUpdateSdkVersionMutation()
  const onSave = () => {
    save({...data, changeLog: changeLog}).then(()=>{setEdit(false)})
  }
  const onCancel = () => {
    setChangeLog(data.changeLog)
    setEdit(false)
  }
  const openNewsletter = () => {
    setNewsletterPopupOpen(true)
  }

  useEffect(() => {
    if(isSuccess && data) {
      setChangeLog(data.changeLog)
    }
  }, [data])


  if ( ! isSuccess ) return (<></>)

  return ( <>
    {
      edit && <ChangeLogEdit
                sdkVersion={data}
                value={changeLog}
                onChange={(e)=>(setChangeLog(e))}
                openNewsletter={openNewsletter}
                onCancel={onCancel}
                onSave={onSave}/>
    }
    {
      !edit && <ChangeLogShow sdkVersion={data} onEdit={()=>setEdit(true)} openNewsletter={openNewsletter} />
    }
    <AppTableBlock apps={data.apps}/>
    <NewsletterModal show={newsletterPopupOpen} onClose={()=>{setNewsletterPopupOpen(false)}} sdkVersion={sdkVersion}/>
  </> );
}

export default SdkVersion;